import { publicGet } from '../../../api';
import { endpoints } from '../../../api/domains/endpoints';

export function getWhatshotPublishersAPI({ token, traceId }) {
    return publicGet(endpoints().whatsHot, { token, traceId });
}

export function getDiscoverPublishersAPI({ token, traceId, page = 1 }) {
    return publicGet(`${endpoints().discoverPublishers}?page=${page}`, { token, traceId });
}
